<script>
  import AtAGlance from './AtAGlance.svelte';
  import AtAGlancePrecinctsReporting from './AtAGlancePrecinctsReporting.svelte';
  /**
   *  @type {object}
   */
  export let races;

  /**
   * @type {Map<string, import('../types.d').Crosswalk>}
   */
  export let crosswalk;

  /** @type {string} **/
  export let page;

  // $: trueOrFalse = []

  function doAllRacesHaveVotes(races){
    let trueOrFalse = []
    races
    .map((r) => {
      r['store'].subscribe((value) => {
        return trueOrFalse.push(value.total_votes > 0);
      });
    })
    return trueOrFalse.every((el) => el === true);
  }

  // $: votesIn = races
  //   .map((r) => {
  //     r['store'].subscribe((value) => {
  //       return trueOrFalse.push(value.total_votes > 0);
  //     });
  //   })
  $: votesInTest = doAllRacesHaveVotes(races);

  // $: console.log('this is a test of votesIn', votesInTest)
</script>



<div class="aag-container {votesInTest ? 'show': 'hidden'}" aria-hidden={votesInTest ? 'false' : 'true'}>
  <p class="aag-title">Key races at a glance</p>
  {#if page !== 'oc' && page !== 'la'}
    <p class="section-deck">Top two advance to November election</p>
    <p class="aag-description"><span><span class="check">✓</span> Winner</span>  <span>* Incumbent</span></p>
  {/if}
  <div class="aag-races-container display-grid grid-cols-2 grid-gap-3 mb-3 mt-1">
    {#each races as race}
      {#if race.race != 'precincts'}
        <div class="race-container" id="aag-{race.id}">
          <AtAGlance 
          race={race.store} 
          label={race.label} 
          {crosswalk}
          />
        </div>
      {/if}
    {/each}
  </div>
</div>